import { ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useAuth } from '../../context/AuthContext';
import { Spinner } from '../ui/Spinner';

export function AdminRoute({ children }: { children: ReactNode }) {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    if (!user) return;
    fetchAuthSession()
      .then((session) => {
        const claim = session.tokens?.idToken?.payload?.['custom:isAdmin'];
        setIsAdmin(claim === 'true');
      })
      .catch(() => setIsAdmin(false));
  }, [user]);

  if (authLoading || (user && isAdmin === null)) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spinner size={40} />
      </div>
    );
  }

  if (!user || isAdmin === false) {
    return <Navigate to="/catalog" replace />;
  }

  return <>{children}</>;
}
